import React, { ReactHTMLElement } from 'react';

interface IRowElementWrapperProps {
    childElement?: HTMLElement;
    children?: React.ReactNode;
    name?: string | number;
}

const RowElementWrapper = ({
    childElement,
    children,
    name,
}: IRowElementWrapperProps) => {
    return (
        <div className="row row-m-b">
            <div className="col-md-12">{children!}</div>
        </div>
    );
};

export default RowElementWrapper;
